const policiesData = {
    "public-protection": {
        title: "Public Protection Policy",
        content: [
            "Observant Security is committed to providing a safe environment for the public and our clients.",
            "Our personnel are trained to maintain public safety while performing their security duties.",
            "We adhere to all UK regulations regarding public protection and door supervisor services.",
            "Our approach includes risk assessments for public areas and proactive threat identification.",
            "We work closely with local authorities to ensure a coordinated response to public safety concerns."
        ]
    },
    "data-protection": {
        title: "Data Protection Policy",
        content: [
            "We take the privacy of our clients and employees seriously, adhering to GDPR and UK Data Protection Act 2018.",
            "All personal data collected through our website and services is stored securely.",
            "We use industry-standard encryption and access controls to protect your information.",
            "Personal information is only used for the purposes of providing security services and communication.",
            "Users have the right to request access to their data and its deletion under applicable laws."
        ]
    },
    "social-media": {
        title: "Social Media Policy",
        content: [
            "Our social media policy ensures professional conduct by all employees online.",
            "We use social media to share industry news, company updates, and safety tips.",
            "Confidential client information is never shared on any social media platform.",
            "We encourage respectful and professional interaction with our online community.",
            "All posts represent the values and professional standards of Observant Security."
        ]
    },
    "business-continuity": {
        title: "Business Continuity Plan",
        content: [
            "Observant Security has robust plans to ensure service delivery during unforeseen disruptions.",
            "Our distributed team and backup systems allow us to maintain operations reliably.",
            "We have procedures for emergency staff deployment and communications during crises.",
            "Regular testing of our systems and procedures ensures we are always ready.",
            "Our commitment is to provide uninterrupted security protection for our clients regardless of external conditions."
        ]
    },
    "mission": {
        title: "Our Mission",
        content: [
            "To provide a secure and safe environment for our clients, our people, and the wider community.",
            "To be the leading service-driven security solution provider across the Midlands.",
            "To deliver exceptional value through professional standards and genuine care.",
            "To leverage our growing expertise in the security industry for the benefit of our clients.",
            "To foster long-term working relationships built on trust, reliability, and excellence."
        ]
    }
};

export default policiesData;
